import React from 'react'

import { useHistory, useLocation } from 'react-router-dom'

import { Formik } from 'formik'

import queryString from 'query-string'

import { ZariContext } from '_zari/context'
import { Form, Col, Row, Button, Divider } from '_zari/core'

import { TiposPreventivoCorrectivoConstant, EstadosTallerConstant, CodigosTransaccionesConstant } from 'constants/index'

import * as TallerService from 'services/taller.service'

import * as FormGroups from './formGroups'
import { ValidationSchema } from './validation'

const MainForm = ({ editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const history = useHistory()
  const location = useLocation()

  const formInitialValues = React.useMemo(() => {
    const queryParams = queryString.parse(location.search)

    return {
      _idCentroCostoNivel1: editarData._idCentroCostoNivel1 ?? queryParams.cc1,
      _idCentroCostoNivel2: editarData._idCentroCostoNivel2 ?? queryParams.cc2,
      _idChofer: editarData._idChofer ?? '',
      _idServicio: editarData._idServicio ?? '',
      _idSubServicio1: editarData._idSubServicio1 ?? '',
      _idSubServicio2: editarData._idSubServicio2 ?? '',
      _idTecnico: editarData._idTecnico ?? '',
      comentario: editarData.comentario ?? '',
      estado: editarData.estado ?? EstadosTallerConstant.ABIERTO,
      fechaIngreso: editarData.fechaIngreso ?? '',
      fechaSalida: editarData.fechaSalida ?? '',
      horas: editarData.horas ?? '',
      monto: editarData.monto ?? '',
      titulo: editarData.titulo ?? '',
      tipoPreventivoCorrectivo: editarData.tipoPreventivoCorrectivo ?? TiposPreventivoCorrectivoConstant.PREVENTIVO
    }
  }, [location, editarData])

  const submitHandler = async data => {
    if (editarData._id) {
      await TallerService.actualizarxId(editarData._id, {
        ...editarData,
        ...data
      })
        .then(() => {
          history.push(`/${CodigosTransaccionesConstant.TALLERES_LISTA}${location.search}`)
          __zariContext.snack('success', 'El registro se ha actualizado')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      await TallerService.nuevo(data)
        .then(() => {
          history.push(`/${CodigosTransaccionesConstant.TALLERES_LISTA}${location.search}`)
          __zariContext.snack('success', 'El registro se ha agregado.')
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }

  return (
    <>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, touched, values, isSubmitting, setFieldValue, handleChange, handleSubmit }) => (
          <Form>
            <Row>
              <Col md={8}>
                <Row>
                  <Col md={6}>
                    <FormGroups.InfoCentroCostoFormGroup iValue={values._idCentroCostoNivel2} />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroups.TituloFormGroup fIsSubmitting={isSubmitting} iError={errors.titulo} iTouched={touched.titulo} />
                  </Col>
                  <Col md={3}>
                    <FormGroups.FechaIngresoFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors.fechaIngreso}
                      iTouched={touched.fechaIngreso}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />
                  </Col>
                  <Col md={3}>
                    <FormGroups.FechaSalidaFormGroup fIsSubmitting={isSubmitting} iError={errors.fechaSalida} iTouched={touched.fechaSalida} />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroups.IdServicioFormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors._idServicio}
                      iTouched={touched._idServicio}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />
                    <FormGroups.IdSubServicio1FormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors._idSubServicio1}
                      iTouched={touched._idSubServicio1}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                      vIdServicio={values._idServicio}
                    />
                    <FormGroups.IdSubServicio2FormGroup
                      fIsSubmitting={isSubmitting}
                      iError={errors._idSubServicio2}
                      iTouched={touched._idSubServicio2}
                      vIdServicio={values._idServicio}
                      vIdSubServicio1={values._idSubServicio1}
                    />
                  </Col>
                  <Col md={3}>
                    <FormGroups.IdTecnicoFormGroup fIsSubmitting={isSubmitting} iError={errors._idTecnico} iTouched={touched._idTecnico} />
                    <FormGroups.IdChoferFormGroup fIsSubmitting={isSubmitting} iError={errors._idChofer} iTouched={touched._idChofer} />
                    <FormGroups.EstadoFormGroup fIsSubmitting={isSubmitting} iError={errors.estado} iTouched={touched.estado} />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroups.ComentarioFormGroup fIsSubmitting={isSubmitting} iError={errors.comentario} iTouched={touched.comentario} />
                  </Col>
                  <Col md={3}>
                    <FormGroups.MontoFormGroup fIsSubmitting={isSubmitting} iError={errors.monto} iTouched={touched.monto} />
                    <FormGroups.HorasFormGroup fIsSubmitting={isSubmitting} iError={errors.horas} iTouched={touched.horas} />
                  </Col>
                  <Col md={3}>
                    <FormGroups.TipoPreventivoCorrectivoFormGroup fIsSubmitting={isSubmitting} iValue={values.tipoPreventivoCorrectivo} />
                  </Col>
                </Row>
                <Row>
                  <Col md={12} className='text-right'>
                    <Divider />
                    <Button onClick={handleSubmit}>Guardar</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default React.memo(MainForm)
